import { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import TabPanel from './TabPanel';
import BreadCrumb from '../atoms/breadcrumb/';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import { marginBottomForBreadCrumb } from '../../config/styles';
import Divider from '@material-ui/core/Divider';
import DeleteTemplateAlert from '../molecules/alerts/DeleteTemplateAlert'
import { handleSnackBar } from '../../store/global/actions';
import { useDispatch } from 'react-redux';
import { toggleRightDrawer, reRenderInfoBuilder } from '../../store/global/actions'


export default function TemplateClusterlet({ element }) {

    const dispatch = useDispatch();
    const defaultAction = { action: '', id: null, item: null };
    const [value, setValue] = useState(0);
    const [action, setAction] = useState(defaultAction);

    const detailsBC = [
        { label: 'Templates', url: null },
        { label: element.name, url: null }
    ];

    const onCompletion = () => {
        dispatch(handleSnackBar({ open: true, message: `Template deleted`, severity: "success" }));
        setAction(defaultAction);
        dispatch(reRenderInfoBuilder());
        dispatch(toggleRightDrawer());

    }

    const onClose = () => {
        setAction(defaultAction)
    }
    return (
        <>
            <AppBar position="static">
                <Tabs value={value} onChange={(e, v) => { setValue(v); setAction({}) }} aria-label="simple tabs example">
                    <Tab label="Details" />
                </Tabs>
            </AppBar>

            <TabPanel value={value} index={0} >
                <Grid container direction={"row"} spacing={2}>

                    <Grid item xs={8}>
                        <BreadCrumb items={detailsBC} />
                    </Grid>

                    <Grid item xs={4} style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Tooltip title="Delete Template" arrow>
                            <IconButton onClick={e => setAction({ action: 'delete_template' })}><DeleteIcon color="secondary" /></IconButton>
                        </Tooltip>
                    </Grid>

                </Grid>
                <Divider style={marginBottomForBreadCrumb} />
                {action.action === '' && <Grid container direction={"row"} spacing={2}>
                    <Grid item xs={12} alignItems='center'>
                        <Typography variant='subtitle1'> {`Template : ${element.name}`}</Typography>

                    </Grid>
                </Grid>}

                {action.action === 'delete_template' && <DeleteTemplateAlert id={element.id} onClose={onClose} onCompletion={onCompletion} />}

            </TabPanel>
        </>
    )
}
